import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnderscoreAndSpace',
  standalone: false
})
export class RemoveUnderscoreAndSpacePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value ? value.replace(/_/g, '') : value;
  }

}
